import React from 'react'

function FeatureCard(props) {

    return (
        <div className='feature-card'>
            <div className='feature-card-title'>{props.title}</div>
            <div className='feature-card-content'>{props.content}</div>
        </div>
    );
}
export default FeatureCard;